/**
 * XtramCollectionsAccountant API – client arrangement (accountant view).
 * Base: api/XtramCollectionsAccountant
 */
import config from "../config";
import selectedEnvironment from "../env";

const BASE_URL = `${config[selectedEnvironment].API_URL}/XtramCollectionsAccountant`;

/**
 * @param {string} caseId - Client case ID
 * @param {string} token - JWT
 * @param {Date|string|null} [startDate]
 * @param {Date|string|null} [endDate]
 * @returns {Promise<{ success: boolean, data?: object, error?: string }>}
 */
export const getClientMonthlyBreakdown = async (caseId, token, startDate = null, endDate = null) => {
  if (!caseId || !token) {
    return { success: false, error: 'caseId and token are required' };
  }
  const params = new URLSearchParams();
  if (startDate) params.set('startDate', startDate instanceof Date ? startDate.toISOString() : String(startDate));
  if (endDate) params.set('endDate', endDate instanceof Date ? endDate.toISOString() : String(endDate));
  const query = params.toString();
  const url = `${BASE_URL}/ClientArrangement/GetMonthlyBreakdown/${encodeURIComponent(caseId)}${query ? `?${query}` : ''}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  const result = await response.json();
  if (!response.ok) {
    return { success: false, error: result.error || `HTTP ${response.status}` };
  }
  return result;
};

/**
 * Get arrangement for client till end date (no monthly breakdown).
 * @param {object} dto - { CaseId, StartMonthDate?, EndMonthDate? }
 * @param {string} token - JWT
 */
export const getArrangementForClientTillEndDate = async (dto, token) => {
  const url = `${BASE_URL}/ClientArrangement/GetArrangementForClientTillEndDate`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(dto),
  });
  const result = await response.json();
  if (!response.ok) {
    return { success: false, error: result.error || `HTTP ${response.status}` };
  }
  return result;
};

export default {
  getClientMonthlyBreakdown,
  getArrangementForClientTillEndDate,
};
